'use client';

import { usePathname } from 'next/navigation';
import Link from 'next/link';

// Actions
import { selectIsLoggedIn } from '../../../lib/features/auth/authSlice';
import { useAppSelector } from '../../../lib/hooks';

function LinkDownload({ href, children }) {
  const pathname = usePathname();
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  return (
    isLoggedIn
      ? (
        <Link
          href={href}
        >
          {children}
        </Link>
      )
      : (
        <Link
          href={`/auth-login?from=${encodeURIComponent(pathname)}`}
        >
          {children}
        </Link>
      )
  );
}

export default LinkDownload;
